import moment from 'moment';
import React, { useState, useEffect } from 'react';

import useGlobalState from '../../GlobalStateContext';
import DateSelectRange from '../../elements/DateSelectRange';
import { TimeRangeName } from '../../helpers/ShowMetrics';

import MetricsDashboard from './MetricsDashboard';

export default function Dashboard() {
    const [url, setUrl] = useState(null);
    const [range, setRange] = useState<TimeRangeName>('today');
    const [startDate, setStartDate] = useState(moment().startOf('day'));
    const [endDate, setEndDate] = useState(moment().endOf('day'));
    const { loggedAdmin } = useGlobalState();

    useEffect(() => {
        if (loggedAdmin) {
            setUrl(`/crea/api/metrics/${loggedAdmin.id}`);
        }
    }, [loggedAdmin]);

    return (
        <div className="dashboard">
            <div className="row no-gutters">
                <div className="dashboard_date-select">
                    <DateSelectRange
                        range={range}
                        setRange={setRange}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                    />
                </div>
            </div>

            <MetricsDashboard url={url} timeRange={{ range, startDate, endDate }} />
        </div>
    );
}
